import React from 'react';

const Pratical = () => {
  return (
    <div id='pricing' className="pricing" >
      <div className="dots dots-up"></div>
      <div className="dots dots-down"></div>
      <h2 className="main-title">About Us</h2>
      <div className="container" >
        <div className="box popular">
          <div className="label">About us</div>
          <div className="title">
            <p className='heading box-title' >Experience Background</p>
          </div>
          <img src="https://thumbs.dreamstime.com/b/black-experience-isolated-vector-icon-simple-element-illustration-startup-concept-icons-editable-logo-symbol-design-white-143598261.jpg" alt="" />
          <div className="price">
            <span className="into">
              <p>
                Hello, I'm <strong>Mohamed Abi</strong>, a passionate and dedicated student in the 3rd year of Software Engineering. I specialize in web development and have a strong foundation in various programming languages, frameworks, and technologies. With a drive to create innovative and user-friendly web experiences, I am constantly exploring new ways to enhance my skills and stay updated with industry trends.
              </p>
            </span>
          </div>

          <p>
            Web development is my true passion, and I find joy in crafting elegant and functional websites that make a positive impact. Throughout my academic journey, I have gained a solid understanding of software engineering principles, algorithms, and data structures, which allows me to approach web development projects with a strong technical foundation.
          </p>

          <h2>Skills and Expertise</h2>
          <ul className='our-skills'>
            <li>Front-end Development: Proficient in HTML5, CSS3,Bootstrap, JavaScript, and modern front-end frameworks such as React.js. Experienced in building responsive and accessible web interfaces using best practices.</li>
            <li>Back-end Development: Knowledge of server-side technologies like Node.js and Express.js or Django , with a focus on creating robust and efficient RESTful APIs. Familiarity with databases such as MongoDB and MySQL for data modeling and management.</li>
            <li>Full Stack Development: Comfortable working on both front-end and back-end aspects of web applications, ensuring seamless integration and optimal performance.</li>
            <li>Version Control: Experienced in using Git and GitHub for collaborative development, version control, and project management.</li>
            <li>Problem Solving: Strong analytical and problem-solving skills, coupled with the ability to break down complex problems into manageable components and propose effective solutions.</li>
          </ul>
          {/* <a href="#our-skills">Skills</a> */}
        </div>
      </div>
    </div>
  );
};

export default Pratical;
